module.exports = __webpack_public_path__ + "img/1569.ef5d5f09.gif";